<template>
    <p class="text-2xl font-semibold text-capDarkPurple">
        <slot />
    </p>
</template>

<script lang="ts">
</script>
